<div class="p-(--padding-card)">
  <ces-route-title [count]="assetGroups.length">
    <ces-button [label]="'common.buttons.add' | transloco" icon="add" (onClick)="createAssetGroup()" />
  </ces-route-title>

  <ces-generic-parent-grid
    (createChildEntity)="createAsset($event)"
    (createEntity)="createAssetGroup()"
    (createRandomChildEntity)="createRandomAsset($event)"
    (createRandomEntity)="createRandomAssetGroup()"
    (deleteChildEntity)="deleteAsset($event)"
    (deleteEntity)="deleteAssetGroup($event)"
    (editChildEntity)="editAsset($event)"
    (editEntity)="editAssetGroup($event)"
    [childEntities]="assetsByGroup"
    [dataLoadingCompleted]="dataLoadingCompleted"
    [entities]="assetGroups"
    [entityDefinition]="assetGroupDefinition" />
</div>
